import React from 'react';
import './ArticleLoader.scss';

const ArticleLoader = ({ url }) => {
  return (
    <div className="article-loader">
      <div className="article-loader-card">
        <div className="article-loader-content">
          <div className="article-loader-thumbnail">
            <div className="pulse-placeholder" />
          </div>
          <div className="article-loader-meta">
            <div className="article-loader-play-button">
              <div className="pulse-placeholder" />
            </div>
            <div className="article-loader-text">
              <div className="article-loader-title">
                <div className="pulse-placeholder" style={{ width: '80%' }} />
              </div>
              <div className="article-loader-subtitle">
                <div className="pulse-placeholder" style={{ width: '60%' }} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ArticleLoader; 